// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

const testimonialsSwiperArray = document.querySelectorAll('.swiper--agent-testimonials')

if (testimonialsSwiperArray) {

  testimonialsSwiperArray.forEach((relatedPropertiesSwiper) => {

    // init Swiper:
    const swiper = new Swiper('.swiper--agent-testimonials', {
      // Optional parameters
      watchOverflow: true,
      centeredSlides: true,
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next--testimonials',
        prevEl: '.swiper-button-prev--testimonials',
      },
    });

  });
}
